module.exports = __webpack_public_path__ + "img/23.18bfe4e1.png";